module.exports = __webpack_public_path__ + "img/iphone-map-NETHERLANDS-nl.b87cf012.webp";